module.exports = __webpack_public_path__ + "static/sun_blade-86cfc393251282800f45e29488a0eb6f.jpeg";